import { createBrowserRouter, Navigate } from 'react-router-dom'
import { featureManifests } from '@/app/navigation/manifests'
import { SessionGate } from '@/platform/session/SessionGate'
import { AuthCallbackPage } from '@/platform/session/AuthCallbackPage'
import { AppShellLayout } from '@/app/shell/AppShellLayout'
import { FeatureRoute } from './FeatureRoute'

export const router = createBrowserRouter([
  { path: '/auth/callback', element: <AuthCallbackPage /> },
  { element: <SessionGate><AppShellLayout /></SessionGate>, children: [
    { index: true, element: <Navigate to="/dashboard" replace /> },
    ...featureManifests.map((feature) => ({ path: feature.path, element: <FeatureRoute feature={feature} /> })),
  ] },
  { path: '*', element: <Navigate to="/" replace /> },
])
